var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"suspend",class:_vm.btnFlag,attrs:{"id":"searchBar","href":"https://assistant.tuolele.cn/index.html","target":"view_windo"}},[_c('img',{attrs:{"src":_vm.Suspend,"alt":"大学生网上兼职"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5373a1e7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/suspend/suspend.vue
// module id = null
// module chunks = 